import React from 'react';
import { withStyles } from 'tss-react/mui';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import AdminTable from '../../../common/components/table/AdminTable';
import AdminModal from '../../../common/components/modal/AdminModal';
import VocationalActivityForm from '../../../common/components/modal/VocationalActivityForm';

const styles = theme => ({
  employmentTypesHeader: {
    padding: `${theme.typography.pxToRem(22)} ${theme.typography.pxToRem(25)} ${theme.typography.pxToRem(25)} ${theme.typography.pxToRem(25)}`
  }
});

class VocationalActivities extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      id: null,
      mode: null,
      open: false,
      refreshTick: 0
    };
  }

  forceRefresh = () => {
    this.setState({ refreshTick: Date.now() });
  };

  handleCloseModal = () => {
    this.setState({ mode: null, open: false, id: null });
  };

  handleOpenAddModal = () => {
    this.setState({ mode: 'add', open: true, id: null });
  };

  handleOpenEditModal = (row) => {
    this.setState({ mode: 'edit', open: true, id: row.id });
  };

  render() {
    const { classes } = this.props;
    const { id, mode, open } = this.state;
    const fields = ['name', 'points'];
    const actions = ['edit', 'delete'];

    return (
      <Grid container spacing={2}>
        <Grid size={12}>
          <Paper>
            <Grid
              container
              className={classes.employmentTypesHeader}
              justifyContent="space-between"
            >
              <Typography variant="h6">
                Vocational Activity Types
              </Typography>
              <Button
                color="secondary"
                onClick={this.handleOpenAddModal}
                size="small"
                variant="contained"
              >
                <Typography variant="button">Add</Typography>
              </Button>
            </Grid>
            <AdminTable
              tableBottomPadding
              actionsSection={actions}
              fields={fields}
              onOpenEditModal={this.handleOpenEditModal}
              refreshTick={this.state.refreshTick}
              resource="vocational_activities"
            />
          </Paper>
        </Grid>
        <AdminModal
          component={VocationalActivityForm}
          fields={fields}
          id={id}
          mode={mode}
          onCloseModal={this.handleCloseModal}
          onForceRefresh={this.forceRefresh}
          open={open}
          resource="vocational_activities"
          title="Vocational Activity"
        />
      </Grid>
    );
  }

}

export default withStyles(VocationalActivities, styles, { withTheme: true });
